<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <!--
      此元件會用來偵測系統之 Status, 例如
       1. User是否為登入
       2. 是否有選擇病人
    -->
    <!--<v-flex xs12 lg12 md12 >-->
    <v-app-bar app  color="toolbar" dark fixed >
        <v-app-bar-nav-icon @click.stop="menu_click"></v-app-bar-nav-icon>
        <!--<v-toolbar-title style="padding-left: 0px" class="toolbarTitle">  </v-toolbar-title>-->
        <img class="toolbarLogo"  />
        <v-spacer></v-spacer>


        <!--<v-btn icon title="回首頁" @click="goHome"><v-icon>home</v-icon></v-btn>-->


        <!-- 我是 snackbar -->
        <v-snackbar
                :timeout="snTimeout"
                v-model="snStatus">
            {{snText}}
        </v-snackbar>



    </v-app-bar>
    <!--<AppFooter style="right:0px;left: 0px;right: 0px;top: 30px;!important;position: relative" v-show="$vuetify.breakpoint.smAndDown" ></AppFooter>-->
    <!--</v-flex>-->
</template>

<script>
    // import AppFooter from './AppFooter'
    export default {
        name: "AppHeader",
        // components:{AppFooter},
        data() {
            return {
                snTimeout:4000,
                snStatus:false,
                snText:'',
                totalGroup:3,
                drawer:'true',

            }
        },
        computed : {

        },

        mounted:function(){
        },
        created(){

        },
        methods: {
            menu_click: function () {
                this.$emit('menu_click', "");
            },

        }
    }
</script>

<style scoped>

    .ptCardBorderM{
        border: 2px solid #fff;
        border-radius: 50%;
        height: 50px;
        width: 50px;
        background-color: #BDEAFF;

    }
    .ptCardBorderF{
        border:  2px solid #fff;
        border-radius:50%;
        height: 50px;
        width: 50px;
        background-color:#FFC9EF ;
    }

    .manIcon{
        content:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAoZJREFUeNrsm9FRwkAQhgPjOzz5SqxArICUkA6ACqQELMEOSAWkhFiBoQLx1aekgnjr/Mww6oxy5PaSy//P3PACe3efu5fdzTlqmiai7DUmAgIkQAIkQIoACZAACZAiQAIkwIHppkuLGWUfU/ORmjHHOFeJkTfL26oza+5CN8aAi83H1ozlP3+SyfcNyOOgAcLjBNyjpYlngKwGBxDwCjPurzR1MCPxBXHcc3gRbBSwOZincN4SvHOI+SAAGk+RM2/hwPTC2N4EfQYizOTJOXE0RW1GrHkeanvgyiG8CLZXIYfwRumPFF4II1l+U9rXnVaSremBcYhzaQJMQpyL3RgCHA7AMsS5NAEeQ5xLuxKpHCfSX9WISWGmIXpgpFTwqzYVtAFuA5nDD0BUB5nDKTLtNr+PNEbq4drF2adUa/sFiFaTi0rBS1vfSyJtNip52rolTxQba9hUl++3cnM8NWeWJt7NSH3B817KYeMC8elCb6zxm7lPeN498Js3nm4lpDgjJ79AK+CxnbmdMOL/ifQ4hAmQIkACJMB+q2sXLE8lXhz9fLMm+V6F/LHozJp9pDHI+RIk0QlgXVqNSBVyRG4ocAsfuaHmi/VTgpxeUbr9pQOACsy89wARkitAmyg7R42qZecy5J0ANOAE2tahp9k0HeQq8K7TADsIzjnIVgDi4pAsahH1Qy9ytLTR/h+3AC/FU7Av8CKstcTa/QFEyO49PCDakKx5jz3ohzC6ya+BFBQPto3Zazwwj8JRrhrCcPtZQABntqFs64FJgH2BRBNgHCDAWBMgRYAESIAESBHgtbJ9J1IGyMJqT7zawRAmQAIkQIoACZAACZAiQAIkQAKkLtKnAAMA9Dnk0/hC0cgAAAAASUVORK5CYII=');

    }

    .femaleIcon{
        content:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAo9JREFUeNrsm9FtwjAQhg3qe7oB6QSlj0iRyAhsUDpBGYGO0A1ggmYEKkXKY8MEhQ1gAmrnLhJVK7WY+Jw4/y+ZvpSz8/XOvru4g9PppCB7DYEAAAEQAAEQAkAABEAAhAAQAAGwZ7pp1Wom+a3+nOkx5nGukkemiuTQliUPWtGNmeSx/lzq8fjPb6yr3y+SXb8BkscZcM+WFl41xEU/ARK8jR73V1ra6pH6Cuthx+EptrFhm705hbOG4J1DzPoBcJKbPW/qwPJU2xbfD2X3QAozc3JGjmY46hFL7ofSHjh3CE+x7XnIIbwQ+iMFGMKULH8KPdedVJIt6YFxiHNJAkxDnAvdGADsD8AyxLkkAe5CnEu6Ejk4TqSpGimS2xA9UAkV/KJNBWmAy0Dm8ASQqoO1wxnW0m1+H2nMQlHXpPm9T6bW9gyQWk0uKgUvbX0/iXSRmDztqSFPPFa2yKa4fL+VG/OpObK0sFfmPbIneP5LOXpwA/HlQm888nfGPuH598Dv3ljfSpjxHhn9Am3DHtua2wkD/J9Il0MYACEABEAA7LTadsGyLvFi9fPN2k7VjdIi2bRlyX7SGMr5Uk6iU4Z1aTWyZ6AGZln99JAbSr5YrxPk2RWl21/aMlADM+s+QArJOUOLhJ3jyFXLymXIuwE4yQ20pUNPs2k6mDvVq3YDbB845yCbAUgXh8yipqobeq+2lgba/8MG4M34FOwKPMVrLXntHgFSyL55OCCaUFStnZ7BQwhTN/kjkILiwbYxe40HZiocZbIhTG4/CgjgyDaUbT0wDbAvkEoCjAMEGEsChAAQAAEQACEAvFa270TKAFlYPROudiCEARAAARACQAAEQACEABAAARAAoYv0JcAA82zJtTOvSlUAAAAASUVORK5CYII=');

    }

    .patIcardM{
        margin-top:5px;
        margin-left:4px;
        margin-right:4px;
        margin-bottom:4px;
        cursor: pointer;
        min-width: 50px !important;
        width: 50px !important;
        max-width: 50px !important;
        /*border: 2px solid #00A0E9;*/
        /*border-radius: 5px;*/
        background: gray;
        min-height: 50px !important;
        /*box-shadow: 1px 0.5px white;*/
        /*box-shadow: 1px 0.5px 5.5px 0px white;*/
    }
    .patIcardM:hover{
        margin-top:5px;
        margin-left:4px;
        margin-right:4px;
        margin-bottom:4px;
        cursor: pointer;
        min-width: 50px !important;
        width: 50px !important;
        max-width: 50px !important;
        min-height: 50px !important;
        /*border: 2px solid #00A0E9;*/
        /*border-radius: 5px;*/
        background: gray;
        box-shadow: 1px 0.5px white;
        /*box-shadow: 1px 0.5px 5.5px 0px white;*/
    }



    /***病患 女性 img 外框↓****/
    .patIcardF{
        margin-top:5px;
        margin-left:4px;
        margin-right:4px;
        margin-bottom:4px;
        cursor: pointer;
        min-width: 70px !important;
        width: 60px !important;
        max-width: 70px !important;
        border: 2px solid #F44DB0;
        border-radius: 5px;
        /*box-shadow: 1px 0.5px white;*/
        /*box-shadow: 1px 0.5px 5.5px 0px white;*/
    }
    .patIcardF:hover{
        margin-top:5px;
        margin-left:4px;
        margin-right:4px;
        margin-bottom:4px;
        cursor: pointer;
        min-width: 70px !important;
        width: 60px !important;
        max-width: 70px !important;
        border: 2px solid #F44DB0;
        border-radius: 5px;
        box-shadow: 1px 0.5px white;
        /*box-shadow: 1px 0.5px 5.5px 0px white;*/
    }

    /***病患 女性 img 外框↑****/
    .scrollPat{
        overflow-x: hidden;
        max-width:860px;
        margin-left:0px;
    }

    .v-cardMediaContent {
        display: -webkit-box;
        display: -ms-flexbox;
        -webkit-box-flex: 1;
        -ms-flex: 1 1 auto;
        flex: 1 1 auto;
        position: relative;
        font-size: 16px;
        vertical-align: center;
        text-align: center;
    }


    .toolbarTitle{
        margin-left: 0px;
        /*font-size: 20px;*/
        /*font-weight: 500;*/
        /*letter-spacing: .02em;*/
        white-space: normal;
        /* overflow: auto; */
        text-overflow: ellipsis;
        min-width: 200px!important;
        max-width: 200px!important;
        width: 200px!important;
    }
    .scrollBtn{  /***往前往後按鈕*/
        height: inherit;
        padding: 10px;
        /*margin: 0px 10px;*/
    }

    .hideDiv{
        display: none;
    }

</style>